"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBContentsTable;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useGetDisplayedItem = _interopRequireDefault(require("../helpers/useGetDisplayedItem"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Global components
 * By Juan Rodrigo <jponceflores@svb.com> (www.svb.com)
 * Summary
 * This component renders a SVB content table (right region)
 */

/**
 * SVBContentsTable
 * @param {array} [items = []] - Array containing the items to be diplayed (check README for more details)
 * @param {boolean} [isSticky = true] - Boolean that determines if the contents table is sticky or not
 * @param {string} [extraClasses = ''] - Extra classes to be added to the button element
 * @param {number} [topOffsetPos = 0 ] - topOffsetPos props to be added for top offset for content Table
 * @returns JSX element
 */
function SVBContentsTable(props) {
  var _props$isSticky;
  const items = props.items || [];
  const isSticky = (_props$isSticky = props.isSticky) !== null && _props$isSticky !== void 0 ? _props$isSticky : true;
  const extraClasses = props.extraClasses || '';
  const testing = props.testing || false;
  const topOffsetPos = props.topOffsetPos || 64;
  const containerClass = 'svb-contents-table';
  const selectedItem = (0, _useGetDisplayedItem.default)(items.map(item => item.id), containerClass, testing);
  const handleRightnavClick = (elemID, e) => {
    e.preventDefault();
    const selectElem = document.getElementById(elemID);
    const positionElemTop = selectElem.getBoundingClientRect().top;
    window.scrollTo({
      behavior: 'smooth',
      top: positionElemTop + window.scrollY - topOffsetPos
    });
  };
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "".concat(containerClass, " ").concat(isSticky ? 'svb-contents-table_sticky ' : '').concat(extraClasses),
    style: {
      top: topOffsetPos
    }
  }, items.map(item => /*#__PURE__*/_react.default.createElement("a", {
    key: "li-".concat(item.id),
    href: "#".concat(item.id),
    onClick: e => handleRightnavClick(item.id, e)
  }, /*#__PURE__*/_react.default.createElement("li", {
    "data-testid": 'ctable-' + "".concat(item.id),
    className: selectedItem === item.id ? "svb-contents-table_selected-item" : ""
  }, item.displayText))));
}
SVBContentsTable.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    displayText: _propTypes.default.string.isRequired
  })).isRequired,
  isSticky: _propTypes.default.bool,
  extraClasses: _propTypes.default.string,
  topOffsetPos: _propTypes.default.number
};